import { GenericQueryPart, Operator, Strategy } from '../entities/generic-query-part.entity';

export class RSQLQueryBuilder {
    private static EQUALS_STRING = '==';
    private static NOT_STRING = '!=';

    private static AND_STRING = ';';
    private static OR_STRING = ',';

    public static build(queryParts: GenericQueryPart[]): string {
        const queryStrings: string[] = queryParts
            .filter(queryPart => queryPart.value && queryPart.value.length > 0)
            .map((queryPart, index) => this.queryPartToString(queryPart, index == 0));

        return queryStrings.join('');
    }

    private static queryPartToString(queryPart: GenericQueryPart, isFirst: boolean) {
        const strategy: string = isFirst ? '' : this.getStrategyString(queryPart.strategy);
        const field: string = queryPart.field;
        const operator: string = this.getOperatorString(queryPart.operator);
        const value = `${this.parseValue(queryPart)}`;

        return `${strategy}${field}${operator}${value}`;
    }

    private static getStrategyString(strategy: Strategy): string {
        switch (strategy) {
            case Strategy.AND:
                return this.AND_STRING;
            case Strategy.OR:
                return this.OR_STRING;

            default:
                console.error(
                    `RSQLQueryBuilder:: Unknown strategy ${strategy} requested. Falling back to AND strategy.`
                );
                return this.AND_STRING;
        }
    }

    private static getOperatorString(operator: Operator): string {
        switch (operator) {
            case Operator.CONTAINS:
            case Operator.EQUALS:
                return this.EQUALS_STRING;
            case Operator.NOT:
                return this.NOT_STRING;

            default:
                console.error(
                    `RSQLQueryBuilder:: Unknown operator ${operator} requested. Falling back to EQUALS operator.`
                );
                return this.EQUALS_STRING;
        }
    }

    private static parseValue(queryPart: GenericQueryPart): string {
        const containsSpaces: boolean = queryPart.value.includes(' ');

        return containsSpaces ? `"${queryPart.value}"` : queryPart.value;
    }
}
